import { createDocument, getAllData, updateDocumentByID } from 'apis/customApiHandler';
import { useState,useCallback, useEffect } from 'react';
import { Button, Input, Select } from 'styled';
import { TH } from 'styled/table';
import ViewList from './ViewList';
import { IoMdArrowBack, IoMdArrowForward } from 'react-icons/io';
import Spinner from 'components/Spinner';
import ReactSelect from 'react-select';
import Modal from 'components/Modal';
import toast from 'react-hot-toast';
import { useQuery } from 'react-query';

const VendorMaster = () => {
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(1);
  const [selectedFleets, setSelectedFleets] = useState([]);
  const [selectedHubs, setSelectedHubs] = useState([]);
  const [fleetMap, setFleetMap] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [vendorsData, setVendorsData] = useState(null);
  const [statusType, setStatusType] = useState("Approved");
  const [modalType, setModalType] = useState(null);
  const[selectedVendorId,setSelectedVendorId]=useState(null);
  
  const handleSearch = async () => {
    setIsLoading(true);
    try {
      const response = await createDocument(`/vendor-contract/get-vendors`, {
        searchQuery: search,
        ...(selectedFleets?.includes("all")
          ? {
              fleets: getFleetOptions()
                .filter(item => item.value !== "all" && item.value !== "clear")
                .map((item) => item.value)
                .join(","),
            }
          : selectedFleets.length && {
              fleets: selectedFleets.map((fleet) => fleet).join(","),
            }),
        ...(selectedHubs?.includes("all")
          ? {
              hubs: getHubOptions()
                .filter(item => item.value !== "all" && item.value !== "clear")
                .map((item) => item.value)
                .join(","),
            }
          : selectedHubs.length && {
              hubs: selectedHubs.map((hub) => hub).join(","),
            }),
            ...(statusType && {
              status: statusType,
            }),
        page,
        limit: 100,
      });
      setVendorsData(response);
    } catch (error) {
      console.error("Error fetching vendor data", error);
    } finally {
      setIsLoading(false);
    }
  };

  const { data: allFleets } = useQuery([`/customer-fleet`], () =>
    getAllData("/customer-fleet", {
      limit: 3000,
      page: 1,
    })
  );
  const { data: allHubs } = useQuery([`/customer-hub`], () =>
    getAllData("/customer-hub", {
      limit: 3000,
      page: 1,
    })
  );

  const totalRecords = vendorsData?.totalRecords || 0;
  const totalPages = Math.ceil(totalRecords / 100);
  const startRecord = (page - 1) * 100 + 1;
  const endRecord = Math.min(startRecord + 99, totalRecords);

  const getFleetOptions = useCallback(() => {
    if (allFleets && allFleets.data && allFleets.data.length) {
      return [
        {
          label: "All",
          value: "all",
        },
        {
          label: "Clear",
          value: "clear",
        },
        ...allFleets?.data?.map((fleet) => {
          return {
            value: fleet._id,
            label: fleet.fleetName,
          };
        }),
      ];
    }
  }, [allFleets]);

  const getHubOptions = useCallback(() => {
    if (allHubs && allHubs.data && allHubs.data.length) {
      return [
       ...selectedFleets?.length ? [{
          label: "All",
          value: "all",
        }]: [],
        ...selectedFleets?.length ? [{
          label: "Clear",
          value: "clear",
        }]: [],
        ...(selectedFleets?.includes("all") ? 
        allHubs?.data?.length &&
          allHubs?.data
            ?.map((hub) => {
              return {
                value: hub._id,
                label: hub.hubName,
              };
            }) : 
        allHubs?.data?.length &&
          allHubs?.data
            ?.filter((hub) => {
              const selectedFleetsVal = allFleets?.data?.filter((fleet) =>
                selectedFleets?.includes(fleet._id)
              );

              return selectedFleetsVal?.some(
                (fleet) => fleet.fleetCode === hub.fleetCode
              );
            })
            ?.map((hub) => {
              return {
                value: hub._id,
                label: hub.hubName,
              };
            })),
      ];
    }
  }, [allFleets, allHubs, selectedFleets]);

  useEffect(()=>{
    handleSearch()
  },[page])

  const approveVendor = async (vendorId) => {
    if ( !vendorId) return;

    const payload = { status: "Approved" };
    try {
      const result = await updateDocumentByID('/vendor-contract/update-vendor-master', vendorId, payload);
      if (result?.success === true) {
        toast.success('Vendor successfully approved');
        handleSearch()
        setModalType(null)
      } else {
        toast.error('Failed to update. Please try again.');
      }
    } catch (error) {
      toast.error('Failed to update. Please try again.');
    }
    setSelectedVendorId(null);
  };

  const rejectVendor = async (vendorId) => {
    if ( !vendorId) return;

    const payload = { status: "Rejected" };
    try {
      const result = await updateDocumentByID('/vendor-contract/update-vendor-master', vendorId, payload);
      if (result?.success === true) {
        toast.success('Vendor successfully rejected');
        handleSearch()
        setModalType(null)
      } else {
        toast.error('Failed to update. Please try again.');
      }
    } catch (error) {
      toast.error('Failed to update. Please try again.');
    }
  };

  const handleApproveClick = (vendorId) => {
    approveVendor(vendorId);
  };

  const handleRejectClick = (vendorId) => {
    rejectVendor(vendorId);
  };

  return (
    <div>
       <div className="w-full px-8 flex justify-center items-center gap-4">

        <label className="w-full py-3">
          Select Fleets
          <ReactSelect
            styles={{
              control: (base, state) => ({
                ...base,
                borderColor: "transparent",
                minWidth: "100%",
                "&:hover": {
                  borderColor: "rgb(34 197 94)",
                },
              }),
            }}
            className="shadow-md rounded-md py-1 mb-2"
            options={getFleetOptions()}
            value={
              selectedFleets &&
              selectedFleets?.map((fleet) => {
                return {
                  value: fleet,
                  label: getFleetOptions()?.find((item) => item?.value === fleet)
                    ?.label,
                };
              })
            }
            onChange={(value) => {
              let allValues = value?.map((item) => item.value);
              if(allValues?.includes("clear")){
                setSelectedFleets([]);
                setSelectedHubs([]);
                return;
              }
              if(!selectedFleets?.includes("all") && allValues.includes("all")){
                setSelectedFleets(["all"]);
                return;
              }

              if (selectedFleets.includes("all")) {
                value = value.filter(item => item.value!== "all")
              }

              let selectedFleetsVal = allFleets?.data?.filter((fleet) =>
                value?.map((item) => item.value)?.includes(fleet._id)
              );

              let selectedHubsVal = allHubs?.data?.filter((hub) =>
                selectedHubs?.map((item) => item)?.includes(hub._id)
              );
              
              setSelectedHubs(
                selectedHubsVal
                  ?.filter((hub) =>
                    selectedFleetsVal?.find(
                      (fleet) => fleet.fleetCode === hub.fleetCode
                    )
                  )
                  .map((hub) => hub._id)
              );
              
              setSelectedFleets(value.map((fleet) => fleet.value));
              }
          }
            name="fleets"
            isMulti = {true}
          />
        </label>

        <label className="w-full py-3">
          Select Hubs
          <ReactSelect
            styles={{
              control: (base, state) => ({
                ...base,
                borderColor: "transparent",
                minWidth: "100%",
                "&:hover": {
                  borderColor: "rgb(34 197 94)",
                },
              }),
            }}
            className="shadow-md rounded-md py-1 mb-2"
            options={getHubOptions()}
            value={
              selectedHubs &&
              selectedHubs?.map((hub) => {
                return {
                  value: hub,
                  label: getHubOptions()?.find((item) => item.value === hub)
                    ?.label,
                };
              })
            }
            onChange={(value) => {
              const allValues = value?.map((item) => item.value);
              if(allValues.includes("clear")){
                setSelectedHubs([])
                return;
              }
              if (!selectedHubs?.includes("all") && allValues.includes("all")) {
                let selectedFleetCodes = allFleets?.data?.filter((fleet) =>
                  selectedFleets?.includes(fleet._id)
                )?.map(fleet=>fleet.fleetCode);

                const selectedHubsData = allHubs?.data?.filter(hub=> selectedFleetCodes?.includes(hub.fleetCode))

                const mp = fleetMap;
                selectedHubsData.map(hub=>{
                  if(selectedFleetCodes?.includes(hub.fleetCode)){
                  if(mp[hub.fleetCode] === undefined) mp[hub.fleetCode] = [];
                  mp[hub.fleetCode] = [...mp[hub.fleetCode], hub._id]
                }})

                setFleetMap(mp);
                setSelectedHubs(["all"])
              } 
              else {
                value = value.filter(value => value.value!== "all")
                let selectedFleetCodes = allFleets?.data?.filter((fleet) =>
                  selectedFleets?.includes(fleet._id)
                )?.map(fleet=>fleet.fleetCode);
              
                const selectedHubsData = allHubs?.data?.filter(hub=> allValues?.includes(hub._id))
                const mp = {};
                selectedHubsData.map(hub=>{
                  mp[hub.fleetCode] = [];
                })

                selectedHubsData.map(hub=>{
                  if(selectedFleetCodes?.includes(hub.fleetCode)){
                  if(mp[hub.fleetCode] === undefined) mp[hub.fleetCode] = [];
                  mp[hub.fleetCode] = [...mp[hub.fleetCode], hub._id]
                }})

                setFleetMap(mp);                  
                setSelectedHubs(value.map((hub) => hub.value));
              }
            }}
            name="hubs"
            isMulti={true}
          />
        </label>

        <label className="w-full  py-3 col-span-2">
                Status
                <Select
                  name="statusType"
                  value={statusType}
                  onChange={(e) => setStatusType(e.target.value)}
                >
                  <option value={"Pending"}>Pending</option>
                  <option value={"Approved"}>Approved</option>
                </Select>
              </label>
        
      </div>

      <div className="m-10">
        <div className="mt-8 flex justify-start gap-6 items-center flex-wrap lg:flex-nowrap">
          <div className="relative w-full">
            <Input
              type="search"
              placeholder="Search Here"
              onChange={(e) => {
                setSearch(e.target.value);
              }}
              onKeyDown={(e) => {
                console.log('e.key',e.key);
                if (e.key === "Enter") {
                  setPage(1);
                  handleSearch();
                }
              }}
            />
          </div>
          <Button type="button" 
            // disabled={(!selectedHubs.length && !search)}
            bgPrimary onClick={() => {
              setPage(1);
              handleSearch();
            }}
          >
            Search
          </Button>
        </div>
      </div>

      {(isLoading) ? (
        <Spinner />
      ) : (
      vendorsData?.paginate?.total ? <div className="flex flex-col m-2 lg:m-10">
        <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
            <div className="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                  <tr>
                    <TH scope="col">S.N.</TH>
                    <TH scope="col">Vendor Name</TH>
                    <TH scope="col">Vendor Code</TH>
                    <TH scope="col">Status</TH>                    
                    <TH scope="col">Effective Date</TH>
                    <TH scope="col">Expiry Date</TH>
                    <TH scope="col">Created On</TH>
                    <TH scope="col" className='text-center'>Actions</TH>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {vendorsData &&
                    vendorsData?.data?.map((vendor, index) => {
                      const actualIndex = startRecord + index;
                    return  <ViewList vendor={vendor} key={vendor._id} index={actualIndex} getData = {handleSearch}
                    setModalType={setModalType}
                    setSelectedVendorId={setSelectedVendorId}
                    />
})}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>: <div className="flex mx-auto justify-center font-medium"> No Data Found</div>
      )}
      
      <div className="container mx-auto flex justify-center items-center gap-2 py-5">
          {vendorsData?.paginate?.total ? <Button
            onClick={() => {
              setPage((p) => Math.max(p - 1, 1));
            }}
            disabled={page === 1}
            className="disabled:pointer-events-none disabled:opacity-70 px-0 "
            primary
          >
            <div className="flex gap-1 items-center">
              <IoMdArrowBack />
              Prev Page
            </div>
          </Button>: <></>}

          {vendorsData?.paginate?.total ?
          <span className="text-gray-600 px-4">{`showing: ${(page - 1) * 100 + 1
          } - ${Math.min(vendorsData?.paginate?.total, page * 100)} of ${vendorsData?.paginate.total
          }`}</span>: <></>
        }

          {vendorsData?.paginate.total > page * 100 ? (
            <Button
              onClick={() => {
                setPage((p) => Math.min(p + 1, vendorsData?.paginate?.total));
              }}
              disabled={page === vendorsData?.paginate?.totalPage}
              className="disabled:pointer-events-none disabled:opacity-70 px-0 "
              primary
            >
              <div className="flex gap-1 items-center">
                Next Page
                <IoMdArrowForward />
              </div>
            </Button>
          ): <></>}
        </div>

        {modalType === "approval" && (
        <Modal
          handleClick={() => {
            setModalType(null);
            setSelectedVendorId(null);
          }}
          title="Update Request"
        >

            <div className="p-4 overflow-x-hidden text-center">
             Are you sure you want to approve this request?
            </div>
         
          <div className="px-5 flex justify-center items-center gap-4 pb-4 flex-wrap sm:w-full text-center">
            
            <Button
              bgSecondary
              style={{ backgroundColor: "darkgrey", color: "white" }}
              onClick={() => {
                setModalType(null);
                setSelectedVendorId(null)
              }}
            >
              Cancel
            </Button>

            <Button
              bgPrimary
              onClick={() => {
                handleApproveClick(selectedVendorId); 
              }}
            >
              {"Approve"}
            </Button>

          </div>
        </Modal>
      )}

        {modalType === "reject" && (
                <Modal
                  handleClick={() => {
                    setModalType(null);
                    setSelectedVendorId(null);
                  }}
                  title="Update Request"
                >

                  <div className="p-4 overflow-x-hidden text-center">
                              Are you sure you want to reject this request?
                              </div>
                
                  <div className="px-5 flex justify-center items-center gap-4 pb-4 flex-wrap sm:w-full">
                    <Button
                      bgSecondary
                      style={{ backgroundColor: "darkgrey", color: "white" }}
                      onClick={() => {
                        setModalType(null);
                        setSelectedVendorId(null)
                      }}
                    >
                      Cancel
                    </Button>
                    <Button
                      bgPrimary
                      style={{ backgroundColor: "red", color: "white" }}
                      onClick={() => {
                        handleRejectClick(selectedVendorId); 
                      }}
                    >
                      {"Reject"}
                    </Button>
                  </div>
                </Modal>
              )}
      
    </div>
  );
};

export default VendorMaster;
